module.exports = __webpack_public_path__ + "static/media/top-question-banner-small.08ea91b7.svg";